/**
 * Re-run Snapmint collection EMI widgets for nc-pr-card grids.
 * Snapmint scans .t4s-product-wrapper + .features-price-section + .t4s-product-price.
 *
 * Runs on:
 * - collection template (.nc-collection-grid)
 * - index / homepage featured-collection (.fcpdp[data-fcpdp-section])
 */
(function () {
  var isCollection = document.body.classList.contains('template-collection');
  var isIndex = document.body.classList.contains('template-index');

  if (!isCollection && !isIndex) return;

  function getRoots() {
    var roots = [];

    function addAll(selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (roots.indexOf(el) !== -1) return;
        roots.push(el);
      });
    }

    if (isCollection) addAll('.nc-collection-grid');
    if (isIndex) addAll('.fcpdp[data-fcpdp-section]');

    return roots;
  }

  var roots = getRoots();
  if (!roots.length) return;

  var normalizeTimer;

  function forEachRoot(callback) {
    roots.forEach(callback);
  }

  function cleanSnapmintTextNodes() {
    forEachRoot(function (root) {
      root.querySelectorAll('.snap_collection_category').forEach(function (container) {
        Array.prototype.forEach.call(container.childNodes, function (node) {
          if (node.nodeType !== Node.TEXT_NODE) return;
          node.textContent = (node.textContent || '')
            .replace(/^\s*or\s*/i, '')
            .replace(/\/\s*month\s*/gi, '');
        });

        var firstSpan = container.querySelector(':scope > span:first-child');
        if (firstSpan) {
          Array.prototype.forEach.call(firstSpan.childNodes, function (node) {
            if (node.nodeType !== Node.TEXT_NODE) return;
            node.textContent = (node.textContent || '')
              .replace(/^\s*or\s*/i, '')
              .replace(/\/\s*month\s*/gi, '');
          });
        }
      });
    });
  }

  function normalizeEmiPills() {
    cleanSnapmintTextNodes();

    forEachRoot(function (root) {
      root.querySelectorAll('.snap_blue_color_text').forEach(function (pill) {
        var priceEl = pill.querySelector('.dp-collection-price');
        var digits = priceEl ? String(priceEl.textContent || '').replace(/\D/g, '') : '';

        if (!digits.length) {
          digits = String(pill.textContent || '').replace(/\D/g, '');
        }

        pill.classList.remove('nc-emi-pill--compact', 'nc-emi-pill--compact-tight');
        pill.classList.toggle('nc-emi-pill--compact', digits.length >= 4);

        if (pill.scrollWidth > pill.clientWidth) {
          pill.classList.add('nc-emi-pill--compact');
        }

        if (pill.scrollWidth > pill.clientWidth) {
          pill.classList.add('nc-emi-pill--compact-tight');
        }

        Array.prototype.forEach.call(pill.childNodes, function (node) {
          if (node.nodeType === Node.TEXT_NODE && /\/\s*month/i.test(node.textContent)) {
            node.textContent = node.textContent.replace(/\/\s*month/gi, '');
          }
        });

        var parent = pill.parentElement;
        if (!parent) return;

        Array.prototype.forEach.call(parent.childNodes, function (node) {
          if (node.nodeType === Node.TEXT_NODE && /\/\s*month/i.test(node.textContent)) {
            node.textContent = node.textContent.replace(/\/\s*month/gi, '');
          }
        });
      });
    });
  }

  function scheduleNormalize() {
    window.clearTimeout(normalizeTimer);
    normalizeTimer = window.setTimeout(normalizeEmiPills, 50);
  }

  function bootSnapmintCollection() {
    if (typeof collectionList !== 'function') return;
    collectionList('.t4s-product-wrapper');
    scheduleNormalize();
  }

  function scheduleBoot() {
    window.setTimeout(bootSnapmintCollection, 300);
    window.setTimeout(bootSnapmintCollection, 2000);
    window.setTimeout(bootSnapmintCollection, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleBoot);
  } else {
    scheduleBoot();
  }

  forEachRoot(function (root) {
    new MutationObserver(scheduleNormalize).observe(root, { childList: true, subtree: true });
  });

  window.addEventListener('resize', scheduleNormalize);
  window.addEventListener('orientationchange', scheduleNormalize);
})();
